export default "__VITE_ASSET__38afbef5__"